import { AppSidebarLayout } from "../layouts";
import { EnvironmentListByOrg } from "../shared";

export const EnvironmentsPage = () => {
  return (
    <AppSidebarLayout>
      <EnvironmentListByOrg />
    </AppSidebarLayout>
  );
};
